// extracted by mini-css-extract-plugin
export default {"ourcover":"OurCover_ourcover__lCxZ4","cover":"OurCover_cover__HhTQ2"};